import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllCodes,
  onCreateCode,
  onDeleteCode,
  onGetCode,
  onUpdateCode,
} from '../../../app/modules/base-definitions/components/code/core/_requests'
import {onGetCodeGroups} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface CodeState {
  codes: any
  code: any
  codeGroups: any
  isLoading: boolean
}
const initialState = {
  codes: [],
  code: null,
  codeGroups: [],
  isLoading: true,
} as CodeState

export const fetchCodeGroups = createAsyncThunk('code/fetchCodeGroups', async () => {
  const data: any = await onGetCodeGroups()
  return data.data.result.items
})

export const fetchCodes = createAsyncThunk('code/fetchCodes', async (param: any) => {
  const data: any = await onGetPagedAllCodes(param)
  return data.data.result
})

export const fetchCode = createAsyncThunk('code/fetchCode', async (param: any) => {
  const data: any = await onGetCode(param)
  return data.data.result
})

export const updateCode = createAsyncThunk('code/updateCode', async (param: any) => {
  const data: any = await onUpdateCode(param)
  return data.data
})

export const createCode = createAsyncThunk('code/createCode', async (param: any) => {
  const data: any = await onCreateCode(param)
  return data.data
})

export const deleteCode = createAsyncThunk('code/deleteCode', async (param: any) => {
  const data: any = await onDeleteCode(param)
  return data.data
})

const codeSlice = createSlice({
  name: 'code',
  initialState,
  reducers: {
    clearCodes: (state) => {
      state.codes = []
    },
    clearCode: (state) => {
      state.code = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCodes.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchCodes.fulfilled, (state: any, action) => {
      state.codes = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchCodes.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchCode.fulfilled, (state: any, action) => {
      state.code = action.payload
    })
    builder.addCase(fetchCodeGroups.fulfilled, (state: any, action) => {
      state.codeGroups = action.payload
    })
  },
})

export const {clearCodes, clearCode, activateLoading} = codeSlice.actions

export default codeSlice.reducer
